"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UcCompanyStatement = exports.UcCompanyGeneral = exports.UcCompanyFormContracts = exports.FieldsetCompanyGeneral = void 0;
const FieldsetCompanyGeneral_yaml_component_1 = __importDefault(require("./FieldsetCompanyGeneral.yaml?component"));
exports.FieldsetCompanyGeneral = FieldsetCompanyGeneral_yaml_component_1.default;
const UcCompanyFormContracts_yaml_component_1 = __importDefault(require("./UcCompanyFormContracts.yaml?component"));
exports.UcCompanyFormContracts = UcCompanyFormContracts_yaml_component_1.default;
const UcCompanyGeneral_yaml_component_1 = __importDefault(require("./UcCompanyGeneral.yaml?component"));
exports.UcCompanyGeneral = UcCompanyGeneral_yaml_component_1.default;
const UcCompanyStatement_yaml_component_1 = __importDefault(require("./UcCompanyStatement.yaml?component"));
exports.UcCompanyStatement = UcCompanyStatement_yaml_component_1.default;
__exportStar(require("./addresses"), exports);
__exportStar(require("./bank-accounts"), exports);
__exportStar(require("./contacts"), exports);
__exportStar(require("./employees"), exports);
